<template>
  <div class="section pt-0 pb-0 mb-20">
    <div>
      <TableauBudget
        :panneaux="panneaux"
        :societeId="societeActiveId"
        :recommandation="recommandation"
        :honoraireForfaitaire="honoraireForfaitaire"/>
      <br>
    </div>
    <div v-if="recommandation && recommandation.intervenants && recommandation.intervenants.length">
      <b-field
        :label="$t('produitsPanier.libelleCommentaire', { societe: societeInitial })"
        custom-class=" has-text-default is-size-7">
        <b-input v-model="recommandation.commentaire" type="textarea" rows="4" expanded></b-input>
      </b-field>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import TableauBudget from './tableauBudget.vue';
import getSocieteInitial from '@/services/general/getSocieteInitial';

const Societe = createNamespacedHelpers('societe');
const Recommandations = createNamespacedHelpers('recommandations');

export default {
  name: 'RecapBudget',
  components: {
    TableauBudget,
  },
  computed: {
    ...Recommandations.mapGetters({
      panneaux: 'panneaux',
      recommandation: 'recommandation',
      honoraireForfaitaire: 'honoraireForfaitaire',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    societeInitial() {
      return getSocieteInitial(this.societeActiveId);
    },
  },
};
</script>
